module.exports = __webpack_public_path__ + "static/media/minus_red.9938bb29.svg";